import React from 'react';

export const EmailVerificationGraphic: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width='390'
      height='281'
      viewBox='0 0 390 281'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M197.318 249.3C244.432 249.3 282.809 222.68 284.587 189.399H110.051C111.829 222.683 150.226 249.3 197.32 249.3H197.318Z'
        fill='#3A3A3A'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M105.081 206.678C107.103 206.678 108.749 205.071 108.749 203.097C108.749 201.124 107.105 199.517 105.081 199.517C103.056 199.517 101.412 201.121 101.412 203.097C101.412 205.073 103.058 206.678 105.081 206.678Z'
        fill='#E5E5EA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M289.951 181.746C293.286 181.746 296 179.035 296 175.697C296 172.358 293.29 169.647 289.951 169.647C286.612 169.647 283.902 172.362 283.902 175.697C283.902 179.031 286.616 181.746 289.951 181.746Z'
        fill='#3A3A3A'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M157.738 257.792C160.569 257.792 162.919 255.442 162.919 252.607C162.919 249.772 160.569 247.422 157.738 247.422C154.906 247.422 152.549 249.772 152.549 252.607C152.549 255.442 154.9 257.792 157.738 257.792Z'
        fill='#358C63'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M277.158 234.996C279.18 234.996 280.826 233.389 280.826 231.416C280.826 229.442 279.183 227.835 277.158 227.835C275.133 227.835 273.49 229.44 273.49 231.416C273.49 233.392 275.133 234.996 277.158 234.996Z'
        fill='#FFBB53'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M264.455 226.834C248.442 240.549 224.318 249.298 197.322 249.298C170.326 249.298 146.202 240.549 130.189 226.834C119.867 216.755 132.08 201.453 145.143 208.964C164.237 219.948 210.253 246.585 264.457 226.834H264.455Z'
        fill='#595959'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M156.847 62.4912C159.266 62.4912 161.191 60.5676 161.191 58.1501C161.191 55.7325 159.266 53.8496 156.847 53.8496C154.429 53.8496 152.549 55.7732 152.549 58.1501C152.549 60.527 154.474 62.4912 156.847 62.4912Z'
        fill='#358C63'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M287.358 121.255C290.192 121.255 292.543 118.948 292.543 116.042C292.543 113.136 290.192 110.885 287.358 110.885C284.525 110.885 282.173 113.192 282.173 116.042C282.173 118.892 284.525 121.255 287.358 121.255Z'
        fill='#E5E5EA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M112.798 124.711C115.631 124.711 117.983 122.361 117.983 119.526C117.983 116.691 115.631 114.341 112.798 114.341C109.965 114.341 107.613 116.691 107.613 119.526C107.613 122.361 109.965 124.711 112.798 124.711Z'
        fill='#3A3A3A'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M227.731 57.3063C231.066 57.3063 233.781 54.5953 233.781 51.2571C233.781 47.919 231.07 45.208 227.731 45.208C224.393 45.208 221.682 47.919 221.682 51.2571C221.682 54.5953 224.393 57.3063 227.731 57.3063Z'
        fill='#FFBB53'
      />
      <g clipPath='url(#clip0_8188_37032)'>
        <path
          d='M152.692 173.035C139.331 173.035 128.462 183.822 128.462 197.082C128.462 210.342 139.331 221.129 152.692 221.129C166.053 221.129 176.923 210.342 176.923 197.082C176.923 183.822 166.053 173.035 152.692 173.035ZM150.692 209.115C150.167 209.115 149.663 208.924 149.273 208.571L137.403 197.851C136.543 197.071 136.482 195.742 137.261 194.89C137.679 194.435 138.25 194.206 138.826 194.206C139.33 194.206 139.839 194.386 140.245 194.75L149.759 203.344C150.199 203.747 150.883 203.713 151.286 203.276L165.246 188.097C166.032 187.244 167.365 187.183 168.224 187.963C168.643 188.338 168.886 188.856 168.913 189.416C168.937 189.972 168.744 190.511 168.359 190.919L152.25 208.438C151.855 208.87 151.284 209.117 150.691 209.117L150.692 209.115Z'
          fill='#358C63'
        />
        <path
          d='M244.407 145.703C244.36 145.755 244.307 145.803 244.245 145.845C229.8 158.653 211.598 174.775 210.796 175.483C209.158 177.121 206.989 178.025 204.678 178.025C202.367 178.025 200.193 177.121 198.555 175.483C183.899 162.512 173.46 153.272 166.029 146.692C166.007 146.67 165.987 146.649 165.96 146.628C155.773 137.61 151.246 133.598 149.231 131.812V173.205C150.181 173.089 151.147 173.03 152.13 173.03C165.651 173.03 176.653 184.104 176.653 197.715C176.653 200.501 176.192 203.176 175.345 205.67H254.738C257.642 205.67 260 203.292 260 200.368V131.88C257.107 134.449 251.183 139.704 244.409 145.703H244.407Z'
          fill='#FFBB53'
        />
        <path
          d='M254.857 128.377H242.692V147.271C249.927 140.98 258.035 134.159 260 132.439C259.462 130.083 257.339 128.377 254.857 128.377Z'
          fill='#ECA63B'
        />
        <path
          d='M168.269 126.659H154.503C151.946 126.659 149.231 128.377 149.231 131.812C150.853 133.25 159.997 141.687 168.269 148.989V126.659Z'
          fill='#ECA63B'
        />
        <path
          d='M224.5 100.894H242.692C242.609 100.802 242.519 100.716 242.43 100.63L222.281 82.2963C222.165 82.1912 222.045 82.0924 221.923 82V98.235C221.923 99.7008 223.08 100.894 224.499 100.894H224.5Z'
          fill='#D1D1D6'
        />
        <path
          d='M200.222 177.285C201.476 178.532 203.143 179.223 204.922 179.223C205.81 179.223 206.673 179.047 207.467 178.719C208.262 178.392 208.988 177.909 209.615 177.285C209.632 177.27 209.647 177.254 209.662 177.239C209.955 176.984 228.201 161.031 242.756 148.29L242.692 103.47C242.692 103.184 242.749 101.164 242.692 100.894L226.712 99.6412C224.443 99.6412 222.602 97.8122 222.602 95.5567L221.923 81.9999C221.792 81.9848 220.439 81.9999 220.308 81.9999H172.178C169.935 81.9999 168.11 83.8138 168.11 86.0429V149.209C182.445 161.743 199.876 176.979 200.174 177.239C200.189 177.254 200.206 177.27 200.222 177.285ZM226.938 124.688H201.195C200.641 124.688 200.191 124.241 200.191 123.69C200.191 123.14 200.641 122.693 201.195 122.693H226.938C227.492 122.693 227.941 123.14 227.941 123.69C227.941 124.241 227.492 124.688 226.938 124.688ZM218.301 108.792H226.938C227.492 108.792 227.941 109.239 227.941 109.79C227.941 110.34 227.492 110.787 226.938 110.787H218.301C217.747 110.787 217.298 110.34 217.298 109.79C217.298 109.239 217.747 108.792 218.301 108.792ZM180.935 108.792H201.193C201.747 108.792 202.197 109.239 202.197 109.79C202.197 110.34 201.747 110.787 201.193 110.787H180.935C180.381 110.787 179.932 110.34 179.932 109.79C179.932 109.239 180.381 108.792 180.935 108.792ZM179.305 123.69C179.305 123.14 179.754 122.693 180.308 122.693H189.723C190.277 122.693 190.727 123.14 190.727 123.69C190.727 124.241 190.277 124.688 189.723 124.688H180.308C179.754 124.688 179.305 124.241 179.305 123.69ZM180.523 137.591C180.523 137.04 180.972 136.593 181.526 136.593H201.79C202.344 136.593 202.789 137.04 202.789 137.591C202.789 138.141 202.344 138.588 201.79 138.588H181.526C180.972 138.588 180.523 138.141 180.523 137.591Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_8188_37032'>
          <rect width='135' height='146' fill='white' transform='translate(125 82)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EmailVerificationGraphic;
